import script from "./ChunksPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChunksPanel.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__